import { createAction, props } from '@ngrx/store';
import { ICreateCustomerModel, ICustomerModel, IUpdateCustomerModel } from '../models/customers.model';

export const GetCustomersList = createAction('[Customers] Get all');
export const GetCustomersListSuccess = createAction(
  '[Customers] Get all customers',
  props<{ customersList: ICustomerModel[] }>()
);
export const GetCustomersListFailed = createAction('[Customers] Get all failed', props<{ Error }>());

export const CreateCustomer = createAction('[Customers] Create', props<{ newCustomer: ICreateCustomerModel }>());

export const CreateCustomerSuccess = createAction(
  '[Customers] Create success',
  props<{ newSavedCustomer: ICustomerModel }>()
);

export const CreateCustomerFailed = createAction('[Customers] Create failed', props<{ Error }>());

export const UpdateCustomer = createAction(
  '[Customers] Update',
  props<{ customerID: string; updateCustomer: IUpdateCustomerModel }>()
);

export const UpdateCustomerSuccess = createAction(
  '[Customers] Update success',
  props<{ updateSavedCustomer: ICustomerModel }>()
);

export const UpdateCustomerFailed = createAction('[Customers] Update failed', props<{ Error }>());

export const ResetCustomerSaveState = createAction('[Customers] reset update state');
